import { useEffect, useRef } from 'react';

function usePressEsc(callback) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    function handlePressEsc(event) {
      if (event.key === 'Escape') {
        callbackRef.current();
      }
    }

    document.addEventListener('keydown', handlePressEsc);

    return () => {
      document.removeEventListener('keydown', handlePressEsc);
    };
  }, []);
}

export default usePressEsc;
